module.exports = __webpack_public_path__ + "img/icon_3.a252a3fc.png";